import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
/* eslint-disable */
import React, { useContext, useRef } from 'react';
import { Input, Select, Switch } from '../index';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import { systemPresetColor } from './constant/systemPresetColor';
import { colorFormat, valOfCorrespondingType, strFixed, getColorObj, highlightPresetColorIndex, presetColorToHEX } from './utils/colorFormat';
import { defaultSystemColor } from './constant/defaultColor';
import { validateColor } from './utils/validateColor';
import { toLowerCase } from './utils/convertLetters';
import Color from 'color';
import { ChromePicker } from 'react-color';
import devWarning from '../_utils/devwarning';
import { useOnClickOutside } from '../_utils/hooks';
var ColorPickerPanel = function ColorPickerPanel(props) {
  var _classNames, _context;
  var setCorrectColorValue = props.setCorrectColorValue,
    setInputColorValue = props.setInputColorValue,
    setAlpha = props.setAlpha,
    setAlphaNoVerifyVal = props.setAlphaNoVerifyVal,
    setIsFollow = props.setIsFollow,
    setClickedColorIndex = props.setClickedColorIndex,
    setShowPanel = props.setShowPanel,
    setColTypeArr = props.setColTypeArr,
    setCurrentColorType = props.setCurrentColorType,
    onChange = props.onChange,
    onVisibleChange = props.onVisibleChange,
    alpha = props.alpha,
    alphaNoVerifyVal = props.alphaNoVerifyVal,
    clickedColorIndex = props.clickedColorIndex,
    colTypeArr = props.colTypeArr,
    correctColorValue = props.correctColorValue,
    currentColorType = props.currentColorType,
    functionalColor = props.functionalColor,
    functionalColorName = props.functionalColorName,
    switchName = props.switchName,
    inputRef = props.inputRef,
    isFollow = props.isFollow,
    presetColor = props.presetColor,
    showSwitch = props.showSwitch,
    showColorTransfer = props.showColorTransfer,
    showPresetColor = props.showPresetColor,
    showColorPickerBox = props.showColorPickerBox,
    showColorPickerPanel = props.showColorPickerPanel,
    value = props.value,
    visible = props.visible,
    showPanel = props.showPanel;
  var panelInputRef = useRef(null);
  var panelClsRef = useRef(null);
  var Option = Select.Option;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    locale = _useContext.locale;
  var colorPickerPrefixCls = getPrefixCls(prefixCls, 'color-picker');
  var panelCls = classNames("".concat(colorPickerPrefixCls, "-panel"));
  var panelChromePickerCls = classNames("".concat(colorPickerPrefixCls, "-panel-chrome"), (_classNames = {}, _defineProperty(_classNames, "".concat(colorPickerPrefixCls, "-panel-chrome-no-box"), !(showColorPickerBox === null || showColorPickerBox === void 0 ? void 0 : showColorPickerBox.showBox)), _defineProperty(_classNames, "".concat(colorPickerPrefixCls, "-panel-chrome-no-hue"), !(showColorPickerBox === null || showColorPickerBox === void 0 ? void 0 : showColorPickerBox.showHue)), _defineProperty(_classNames, "".concat(colorPickerPrefixCls, "-panel-chrome-no-opacity"), !(showColorPickerBox === null || showColorPickerBox === void 0 ? void 0 : showColorPickerBox.showOpacity)), _classNames));
  var panelFollowThemeCls = classNames("".concat(colorPickerPrefixCls, "-panel-switch"));
  var panelContainerCls = classNames("".concat(colorPickerPrefixCls, "-panel-container"));
  var panelInputCls = classNames("".concat(colorPickerPrefixCls, "-panel-container-input"));
  var transparentCls = classNames("".concat(colorPickerPrefixCls, "-panel-container-transparent"));
  var colorDivContainerCls = classNames("".concat(colorPickerPrefixCls, "-panel-colorDivContainer"), _defineProperty({}, "".concat(colorPickerPrefixCls, "-panel-colorDivContainer-unset-color"), (presetColor === null || presetColor === void 0 ? void 0 : presetColor.length) === 0));
  var colorLiClick = function colorLiClick(index, colorValue) {
    var formatArr = colorFormat(colorValue, alpha);
    var formatValue = toLowerCase(formatArr[valOfCorrespondingType(currentColorType)].value);
    setIsFollow(false);
    if (isFollow) {
      setAlpha(1);
      setAlphaNoVerifyVal(100 + '%');
    }
    if (value === undefined) {
      setInputColorValue(formatValue);
      setCorrectColorValue(formatValue);
      setColTypeArr(formatArr);
    }
    setClickedColorIndex(index);
    onChange && onChange(formatValue, colTypeArr);
  };
  var handleTypeChange = function handleTypeChange(selectValue, option) {
    setCurrentColorType(option.label);
    if (value === undefined) {
      setCorrectColorValue(selectValue);
      setInputColorValue(selectValue);
    }
    onChange && onChange(selectValue, colTypeArr);
  };
  var setPanelState = function setPanelState(formatArr, correctColorValue, inputColorValue, alpha, alphaStr) {
    setColTypeArr(formatArr);
    setCorrectColorValue(correctColorValue);
    setInputColorValue(inputColorValue);
    alpha && setAlpha(alpha);
    alphaStr && setAlphaNoVerifyVal(alphaStr);
  };
  var handleAlphaChange = function handleAlphaChange(e) {
    var regPercentage = /^(0|[1-9][0-9]?|100)%$/;
    var regDot = /^(0(\.\d+)?|1(\.0+)?)$/;
    var val = e.target.value;
    var formatArr, outValue;
    if (value === undefined) {
      setAlphaNoVerifyVal(e.target.value);
      if (regPercentage.test(val)) {
        formatArr = colorFormat(correctColorValue, +val.replace('%', '') / 100, 'all', true);
        outValue = formatArr[valOfCorrespondingType(currentColorType)].value;
        setPanelState(formatArr, outValue, outValue, +val.replace('%', '') / 100);
        setClickedColorIndex(highlightPresetColorIndex(formatArr[0].value, presetColorToHEX(presetColor || systemPresetColor)));
      } else if (regDot.test(val)) {
        formatArr = colorFormat(correctColorValue, +val, 'all', true);
        outValue = formatArr[valOfCorrespondingType(currentColorType)].value;
        setPanelState(formatArr, outValue, outValue, strFixed(val, 2));
        setClickedColorIndex(highlightPresetColorIndex(formatArr[0].value, presetColorToHEX(presetColor || systemPresetColor)));
      } else {
        formatArr = colorFormat(correctColorValue, 1, 'all', true);
        outValue = formatArr[valOfCorrespondingType(currentColorType)].value;
        setPanelState(formatArr, outValue, outValue, 1);
      }
      onChange && onChange(outValue, formatArr);
    }
  };
  var handleAlphaBlur = function handleAlphaBlur(e) {
    var regPercentage = /^(0|[1-9][0-9]?|100)%$/;
    var regDot = /^(0(\.\d+)?|1(\.0+)?)$/;
    var val = e.target.value;
    if (regPercentage.test(val)) {
      setAlphaNoVerifyVal(val);
    } else if (regDot.test(val)) {
      setAlphaNoVerifyVal(strFixed(+val * 100) + '%');
    } else {
      setAlphaNoVerifyVal('100%');
    }
  };
  var handleSwitchChange = function handleSwitchChange(switchValue) {
    var formatArr;
    if (functionalColor) {
      var inputValType = validateColor(functionalColor);
      if (inputValType) {
        if (value === undefined) {
          setIsFollow(switchValue);
          if (switchValue) {
            formatArr = colorFormat(functionalColor, alpha);
            setPanelState(formatArr, formatArr[valOfCorrespondingType(currentColorType)].value, functionalColorName, strFixed(Color(getColorObj(functionalColor)).alpha(), 2), strFixed(Color(getColorObj(functionalColor)).alpha(), 2) * 100 + '%');
            setClickedColorIndex(highlightPresetColorIndex(formatArr[0].value, presetColorToHEX(presetColor || systemPresetColor)));
          } else {
            formatArr = colorFormat(defaultSystemColor, 1, 'all', true);
            setPanelState(formatArr, defaultSystemColor, '', 1, 100 + '%');
            setClickedColorIndex(-1);
          }
        }
      }
      devWarning(!inputValType, 'color-picker', "'themeColor' must be hexadecimal, RGB, HSB, HSL or English color name");
    }
    if (switchValue) {
      onChange && onChange(functionalColorName, formatArr);
    } else {
      onChange && onChange(defaultSystemColor, formatArr);
    }
  };
  var handleChromeChange = function handleChromeChange(color) {
    var formatArr = colorFormat(color.hex, color.rgb.a);
    var colorObj = formatArr[valOfCorrespondingType(currentColorType)];
    if (value === undefined) {
      setIsFollow(false);
      setPanelState(formatArr, colorObj.value, colorObj.value, color.rgb.a, (color.rgb.a * 100).toFixed() + '%');
      setClickedColorIndex(highlightPresetColorIndex(formatArr[0].value, presetColorToHEX(presetColor || systemPresetColor)));
    }
    onChange && onChange(colorObj.value, formatArr);
  };
  var checkUserPresetColor = function checkUserPresetColor(colorArr) {
    if (!colorArr) return false;
    var isTrueFormat = colorArr.every(function (hexColor) {
      return ['HEX', 'HSB', 'RGB', 'HSL', 'colorName'].indexOf(validateColor(hexColor)) !== -1;
    });
    devWarning(!isTrueFormat, 'color-picker', "'presetColor' must be an array of hexadecimal, RGB, HSB, HSL or English color name string type");
    return isTrueFormat;
  };
  useOnClickOutside([panelClsRef, inputRef], function () {
    if (typeof visible === 'undefined') {
      setShowPanel(false);
    }
    showPanel && onVisibleChange && onVisibleChange(false);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, showColorPickerPanel && /*#__PURE__*/React.createElement("div", {
    className: panelCls,
    ref: panelClsRef
  }, /*#__PURE__*/React.createElement(ChromePicker, {
    className: panelChromePickerCls,
    color: colTypeArr[2].value,
    onChange: handleChromeChange
  }), functionalColor && showSwitch && /*#__PURE__*/React.createElement("div", {
    className: panelFollowThemeCls
  }, /*#__PURE__*/React.createElement("span", null, (switchName === null || switchName === void 0 ? void 0 : switchName.internationalName) && locale.getLangMsg('ColorPicker', switchName.internationalName) || switchName.name), /*#__PURE__*/React.createElement(Switch, {
    checked: isFollow,
    onChange: handleSwitchChange
  })), showColorTransfer && /*#__PURE__*/React.createElement("div", {
    className: panelContainerCls
  }, /*#__PURE__*/React.createElement("div", {
    className: panelInputCls,
    ref: panelInputRef
  }, /*#__PURE__*/React.createElement(Select, {
    disabled: isFollow,
    borderType: "bordered",
    value: correctColorValue,
    placeholder: "#",
    onChange: handleTypeChange,
    optionLabelProp: "value",
    getPopupContainer: function getPopupContainer() {
      return panelInputRef.current;
    }
  }, _mapInstanceProperty(colTypeArr).call(colTypeArr, function (obj, i) {
    return /*#__PURE__*/React.createElement(Option, {
      title: obj.value,
      value: obj.value,
      className: classNames({
        'active-option': obj.type === currentColorType && obj.value === correctColorValue
      }),
      key: i
    }, obj.type);
  }))), /*#__PURE__*/React.createElement(Input, {
    className: transparentCls,
    onChange: handleAlphaChange,
    onBlur: handleAlphaBlur,
    borderType: "bordered",
    value: alphaNoVerifyVal,
    disabled: isFollow
  })), showPresetColor && /*#__PURE__*/React.createElement("div", {
    className: colorDivContainerCls
  }, _mapInstanceProperty(_context = checkUserPresetColor(presetColor) && presetColorToHEX(presetColor) || systemPresetColor).call(_context, function (colorValue, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: i,
      style: {
        backgroundColor: "".concat(colorValue)
      },
      onClick: function onClick() {
        colorLiClick(i, colorValue);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames('square', {
        'square-click': clickedColorIndex === i
      })
    }));
  }))));
};
ColorPickerPanel.displayName = 'ColorPickerPanel';
export default ColorPickerPanel;